import { AppUtils } from '../../shared/utils/index';
import { CooperationDataModel } from "../models/view/CooperationData";

export class CooperationViewService {
	private readonly excludeIds: string[];
	private readonly rules: string[];
	private readonly $fieldset: JQuery;

	private readonly fieldSelector = "input, select";

	constructor(fieldset: JQuery) {
		this.$fieldset = fieldset;
		this.rules = ["required", "email", "minlength", "maxlength", "notequals", "digits"];
		this.excludeIds = ["cooperation-targetemail", "cooperation-subject"];
	}

	/***
	 * merges the active validatorRules with the validatorRules defined in the markup.
	 * @param validatorRules - active validatorRules
	 */
	public mergeWithValidatorRulesFromMarkup(validatorRules: ValidationRules): ValidationRules {
		const dynamicValidationRules = this.getValidatorRulesFromDataAttributes();
		return $.extend(true, {}, validatorRules, dynamicValidationRules);
	}

	/***
	 * Retrieves the ValidatorRules from the data attributes of all input & select elements in the viewServices Fieldset.
	 */
	private getValidatorRulesFromDataAttributes(): ValidationRules {
		const validatorRules = {} as ValidationRules;
		validatorRules.rules = {};
		this.$fieldset.find(this.fieldSelector).each((index, element) => {
			const $element = $(element);
			const dataValidation: string = $element.data('validation');
			if (!AppUtils.Helper.isEmptyString(dataValidation)) {
				validatorRules.rules[dataValidation] = {};
				this.rules.forEach((rule) => {
					const ruleValue = $element.data(rule);
					if (ruleValue !== undefined) {
						validatorRules.rules[dataValidation][rule] = ruleValue;
					}
				});
			}
		});
		return validatorRules;
	}

	/***
	 * Retrieves the Dynamic Fields' values from the markup.
	 */
	public getDynamicsModelFromMarkup(): { [key: string]: any } {
		const dynamicsModel = {} as { [key: string]: any };
		this.$fieldset.find(this.fieldSelector).each((index, element) => {
			if (this.excludeIds.indexOf(element.id) < 0) {
				const $elm = $(element);
				dynamicsModel[element.id] = element.tagName === "SELECT" ?
					this.checkElemAndAddHyphen($elm) : $elm.val();
			}
		});
		return dynamicsModel;
	}

	private checkElemAndAddHyphen(elem: JQuery): string {
		if (elem && elem.val() !== "") {
			return `${elem.val()} - ${elem.find('option:selected').html()}`;
		}
		else {
			return elem.find('option:selected').html();
		}
	}

	/***
	 * Updates the values in the view.
	 */
	public setModelToView(model: { [key: string]: any }): void {
		if (model) {
			for (const key in model) {
				this.$fieldset.find(`#${key}`).val(model[key]);
			}
		}
	}

	/***
	 * Gets the Form's hidden fields' values from the markup.
	 */
	public getCooperationFormModelFromMarkup(): CooperationDataModel {
		const model = new CooperationDataModel();
		model.Targetemail = $("#cooperation-targetemail").val() as string;
		model.Subject = $("#cooperation-subject").val() as string;
		return model;
	}
}
